import { render, staticRenderFns } from "./SimManagementTab.vue?vue&type=template&id=468c8774&scoped=true&"
import script from "./SimManagementTab.vue?vue&type=script&lang=js&"
export * from "./SimManagementTab.vue?vue&type=script&lang=js&"
import style0 from "./SimManagementTab.vue?vue&type=style&index=0&id=468c8774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c8774",
  null
  
)

export default component.exports